import PropTypes from 'prop-types'
import LinkButton from '../ui/LinkButton'
import styles from './BordeDetalle.module.css'

const BordeDetalle = ({
  className = '',
  vieneDeTiendas,
  titulo,
  onCerrarClick,
  children
}) => {
  return (
    <fieldset
      className={`${className} ${vieneDeTiendas ? 'fieldsetBordeDetalle' : 'fieldset'}`}
    >
      <div className={styles.flex}>
        <legend>{titulo}</legend>
        <LinkButton onClick={onCerrarClick} className={`btn x-times ${styles.closeIcon}`}>
          <i className="fa fa-times f-size-25 " aria-hidden="true" />
        </LinkButton>
      </div>
      {children}
    </fieldset>
  )
}

BordeDetalle.propTypes = {
  className: PropTypes.string,
  vieneDeTiendas: PropTypes.bool,
  titulo: PropTypes.string.isRequired,
  onCerrarClick: PropTypes.func.isRequired,
  children: PropTypes.node
}

export default BordeDetalle
